import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import seo from './pages.json'


// Keeps <head> in sync with the current route during client-side navigation.
// The same data is baked into static HTML per page by scripts/seo-postbuild.js.

const setTag = (selector, tagName, attrs) => {
    let el = document.head.querySelector(selector)
    if (!el) {
        el = document.createElement(tagName)
        document.head.appendChild(el)
    }
    Object.entries(attrs).forEach(([key, value]) => el.setAttribute(key, value))
}

const normalizePath = (pathname) => {
    const path = pathname.replace(/\/+$/, '') || '/'
    return path === '/home' ? '/' : path
}

const RouteMeta = () => {
    const { pathname } = useLocation()

    useEffect(() => {
        const path = normalizePath(pathname)
        const page = seo.pages[path]
        const robots = document.head.querySelector('meta[name="robots"]')

        if (!page) {
            setTag('meta[name="robots"]', 'meta', { name: 'robots', content: 'noindex, follow' })
            document.head.querySelector('link[rel="canonical"]')?.remove()
            return
        }
        robots?.remove()

        const url = seo.siteUrl + (path === '/' ? '/' : path)

        document.title = page.title
        setTag('meta[name="description"]', 'meta', { name: 'description', content: page.description })
        setTag('link[rel="canonical"]', 'link', { rel: 'canonical', href: url })
        setTag('meta[property="og:title"]', 'meta', { property: 'og:title', content: page.title })
        setTag('meta[property="og:description"]', 'meta', { property: 'og:description', content: page.description })
        setTag('meta[property="og:url"]', 'meta', { property: 'og:url', content: url })
        setTag('meta[name="twitter:title"]', 'meta', { name: 'twitter:title', content: page.title })
        setTag('meta[name="twitter:description"]', 'meta', { name: 'twitter:description', content: page.description })
    }, [pathname])

    return null
}

export default RouteMeta
